import React, { useEffect, useState } from "react";
import styles from "../MegaMenu.css";
import { FADEIN_DELAY } from "./MegaMenuLinksSection";
import { Link } from "react-router-dom";

export default function AnimatedLink({ url, title, setActiveMenuIndex, count, external }) {
  const [className, setClassName] = useState(styles.Link);

  useEffect(() => {
    setClassName(styles.Link);
    setTimeout(() => {
      setClassName([styles.Link, styles["Link_visible"]].join(" "));
    }, count * FADEIN_DELAY);
  }, [setActiveMenuIndex]);

  if (external) {
    return (
      <a
        className={className}
        href={url}
        onClick={() => setActiveMenuIndex(undefined)}
        target="_blank"
      >
        {title}
      </a>
    );
  }

  return (
    <Link
      className={className}
      to={url}
      onClick={() => setActiveMenuIndex(undefined)}
    >
      {title}
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/MegaMenu/Components/AnimatedLink.js